// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MentorsPage.css */
/* Всі стилі обгорнуті селектором .mentors-page, щоб не впливати на інші сторінки */

.mentors-page .mentor-tasks-layout {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }
  
  .mentors-page .columns-row {
    display: flex;
    gap: 20px;
    width: 100%;
  }
  
  .mentors-page .columns-row .mentor-tasks-column {
    flex: 1 1;
    min-width: 0; /* Для запобігання переповнення */
  }
  
  .mentors-page .mentor-tasks-column {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: fit-content;
    max-height: 800px;
  }
  
  .mentors-page .column-header {
    padding: 15px 20px;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
  }
  
  .mentors-page .column-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    text-shadow: 0 1px 2px rgba(0,0,0,0.2);
  }
  
  .mentors-page .tasks-count {
    background: rgba(255,255,255,0.25);
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
  }
  
  .mentors-page .tasks-container {
    padding: 15px;
    overflow-y: auto;
    flex: 1 1;
    background: #f8f9fc;
  }
  
  .mentors-page .visible-tasks {
    margin-bottom: 15px;
  }
  
  .mentors-page .hidden-tasks-section {
    border-top: 2px dashed #cbd5e0;
    padding-top: 15px;
    margin-top: 5px;
  }
  
  .mentors-page .hidden-tasks-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: #e9ecef;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    color: #2d3748;
    font-weight: 500;
    transition: background-color 0.2s;
    border: 1px solid #d0d9e4;
  }
  
  .mentors-page .hidden-tasks-header:hover {
    background: #dee2e6;
  }
  
  .mentors-page .hidden-tasks-icon {
    font-size: 12px;
    color: #4a5568;
  }
  
  .mentors-page .hidden-tasks-title {
    font-weight: 600;
  }
  
  .mentors-page .hidden-tasks-list {
    margin-top: 12px;
  }
  
  .mentors-page .mentor-task-card {
    position: relative;
    background: white;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 14px;
    overflow: hidden;
    transition: all 0.2s ease;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  }
  
  .mentors-page .mentor-task-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.1);
    border-color: #cbd5e0;
  }
  
  .mentors-page .mentor-task-card.blocker {
    border-left: 5px solid #f44336;
    background: #fff5f5;
  }
  
  .mentors-page .mentor-task-card.blocker:hover {
    background: #fff0f0;
  }
  
  .mentors-page .task-progress-bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    transition: width 1s linear;
    opacity: 0.9;
  }
  
  .mentors-page .task-content {
    position: relative;
    z-index: 1;
  }
  
  .mentors-page .task-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
    color: #4a5568;
    font-weight: 500;
  }
  
  .mentors-page .user-name {
    font-weight: 600;
    color: #1a202c;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  
  .mentors-page .user-name span.role-icon {
    font-size: 16px;
    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.1));
  }
  
  .mentors-page .start-time {
    color: #718096;
    font-weight: 500;
    background: #edf2f7;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
  }
  
  .mentors-page .task-name {
    font-weight: 600;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #1a202c;
    font-size: 15px;
  }
  
  .mentors-page .task-project {
    font-size: 13px;
    color: #4a5568;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: #edf2f7;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
    max-width: 100%;
  }
  
  .mentors-page .task-timer {
    font-size: 15px;
    color: #2d3748;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
    background: #e2e8f0;
    padding: 4px 10px;
    border-radius: 20px;
    width: fit-content;
  }
  
  .mentors-page .task-timer:before {
    content: "⏱️";
    margin-right: 4px;
    font-size: 14px;
  }
  
  .mentors-page .task-link-arrow {
    position: absolute;
    bottom: 14px;
    right: 14px;
    font-size: 20px;
    color: #a0aec0;
    opacity: 0;
    transition: opacity 0.2s, color 0.2s;
    background: white;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .mentors-page .mentor-task-card:hover .task-link-arrow {
    opacity: 1;
    color: #4299e1;
  }
  
  .mentors-page .no-tasks-message {
    text-align: center;
    color: #718096;
    padding: 30px 20px;
    font-style: italic;
    background: #f7fafc;
    border-radius: 6px;
    border: 1px dashed #cbd5e0;
  }
  
  .mentors-page .show-all-tasks-btn {
    padding: 12px 24px;
    background: #4299e1;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    align-self: center;
    margin: 15px 0 10px;
    min-width: 220px;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(66, 153, 225, 0.3);
    border: 1px solid #3182ce;
  }
  
  .mentors-page .show-all-tasks-btn:hover {
    background: #3182ce;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(66, 153, 225, 0.4);
  }
  
  .mentors-page .show-all-tasks-btn:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(66, 153, 225, 0.3);
  }
  
  .mentors-page .all-tasks-view {
    margin-top: 25px;
  }
  
  .mentors-page .all-tasks-view h3 {
    margin-bottom: 15px;
    color: #1a202c;
    font-size: 20px;
    font-weight: 600;
    padding-left: 5px;
  }
  
  .mentors-page .users-columns {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
  }
  
  .mentors-page .user-column {
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.08);
    overflow: hidden;
    border: 1px solid #e2e8f0;
  }
  
  .mentors-page .user-header {
    padding: 14px 16px;
    background: #f8fafc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid #e2e8f0;
    transition: background-color 0.2s;
  }
  
  .mentors-page .user-header:hover {
    background: #edf2f7;
  }
  
  .mentors-page .user-header .user-name {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
    color: #1a202c;
    font-size: 15px;
  }
  
  .mentors-page .role-icon {
    font-size: 20px;
    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.1));
  }
  
  .mentors-page .collapse-btn {
    background: white;
    border: 1px solid #cbd5e0;
    cursor: pointer;
    font-size: 14px;
    color: #4a5568;
    padding: 6px 12px;
    border-radius: 20px;
    transition: all 0.2s;
    font-weight: 500;
  }
  
  .mentors-page .collapse-btn:hover {
    background: #e2e8f0;
    border-color: #a0aec0;
  }
  
  .mentors-page .user-column.collapsed .user-header {
    background: #edf2f7;
    border-bottom: none;
  }
  
  .mentors-page .user-statuses {
    padding: 12px;
    background: #ffffff;
  }
  
  .mentors-page .status-section {
    margin-bottom: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
    background: white;
  }
  
  .mentors-page .status-header {
    padding: 10px 12px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
    border-bottom: 1px solid #e2e8f0;
    transition: background-color 0.2s;
  }
  
  .mentors-page .status-header:hover {
    background: #edf2f7;
  }
  
  .mentors-page .status-name {
    flex: 1 1;
    font-weight: 600;
  }
  
  .mentors-page .status-name[data-status="В роботі"],
  .mentors-page .status-name[data-status="В работе"],
  .mentors-page .status-name[data-status="In progress"] {
    color: #2563eb;
  }
  
  .mentors-page .status-name[data-status="Черговому"],
  .mentors-page .status-name[data-status="Дежурному"] {
    color: #dd6b20;
  }
  
  .mentors-page .status-name[data-status="В черзі"],
  .mentors-page .status-name[data-status="В очереди"] {
    color: #7b3fe4;
  }
  
  .mentors-page .status-name[data-status="В черзі (м'яч не у нас)"],
  .mentors-page .status-name[data-status="В очереди (мяч не у нас)"] {
    color: #b45309;
  }
  
  .mentors-page .task-count {
    color: #4a5568;
    font-size: 13px;
    font-weight: 500;
    background: #e2e8f0;
    padding: 2px 8px;
    border-radius: 16px;
  }
  
  .mentors-page .collapse-icon {
    font-size: 12px;
    color: #718096;
    margin-left: 4px;
  }
  
  .mentors-page .tasks-list {
    padding: 8px;
    background: white;
  }
  
  .mentors-page .task-item-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-bottom: 1px solid #f0f4f8;
    font-size: 13px;
    transition: background-color 0.2s;
    background: white;
  }
  
  .mentors-page .task-item-wrapper:hover {
    background: #f8fafc;
  }
  
  .mentors-page .task-item-wrapper:last-child {
    border-bottom: none;
  }
  
  .mentors-page .task-info-compact {
    flex: 1 1;
    min-width: 0;
  }
  
  .mentors-page .task-name-small {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #1a202c;
    font-weight: 500;
    margin-bottom: 4px;
  }
  
  .mentors-page .task-time-small {
    font-size: 12px;
    color: #718096;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  
  .mentors-page .task-time-small:before {
    content: "⏱️";
    font-size: 11px;
    opacity: 0.7;
  }
  
  .mentors-page .task-link-small {
    color: #4299e1;
    text-decoration: none;
    font-size: 16px;
    padding: 6px 10px;
    opacity: 0;
    transition: all 0.2s;
    background: #ebf8ff;
    border-radius: 20px;
    font-weight: 600;
  }
  
  .mentors-page .task-item-wrapper:hover .task-link-small {
    opacity: 1;
    color: #2b6cb0;
  }
  
  /* Стилі для скролу */
  .mentors-page .tasks-container::-webkit-scrollbar,
  .mentors-page .tasks-list::-webkit-scrollbar {
    width: 8px;
  }
  
  .mentors-page .tasks-container::-webkit-scrollbar-track,
  .mentors-page .tasks-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .mentors-page .tasks-container::-webkit-scrollbar-thumb,
  .mentors-page .tasks-list::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
  }
  
  .mentors-page .tasks-container::-webkit-scrollbar-thumb:hover,
  .mentors-page .tasks-list::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
  
  /* Стилі для loading та error станів */
  .mentors-page .loading,
  .mentors-page .error {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #4a5568;
  }
  
  .mentors-page .error {
    color: #e53e3e;
  }
  /* MentorsPage.css - додайте ці стилі до існуючих */

/* Стилі для колонки запитів на допомогу */
.mentors-page .help-requests-column {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
  margin-top: 10px;
  border: 1px solid #e2e8f0;
}

.mentors-page .help-requests-header {
  padding: 15px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-weight: 600;
  transition: opacity 0.2s;
}

.mentors-page .help-requests-header:hover {
  opacity: 0.9;
}

.mentors-page .help-requests-icon {
  font-size: 14px;
}

.mentors-page .help-requests-title {
  font-size: 16px;
}

.mentors-page .help-requests-content {
  padding: 15px;
  background: #f8f9fc;
}

.mentors-page .help-requests-section {
  margin-bottom: 20px;
}

.mentors-page .help-requests-subheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #e9ecef;
  border-radius: 6px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #2d3748;
}

.mentors-page .requests-count {
  background: #667eea;
  color: white;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 12px;
}

.mentors-page .help-requests-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mentors-page .help-request-card {
  background: white;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
}

.mentors-page .help-request-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transform: translateY(-1px);
}

.mentors-page .help-request-info {
  flex: 1 1;
}

.mentors-page .help-request-user {
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 4px;
  font-size: 14px;
}

.mentors-page .help-request-task {
  font-size: 13px;
  color: #4a5568;
  margin-bottom: 4px;
  word-break: break-word;
}

.mentors-page .help-request-project {
  font-size: 12px;
  color: #718096;
  margin-bottom: 4px;
}

.mentors-page .help-request-time {
  font-size: 12px;
  color: #e53e3e;
  font-weight: 500;
}

.mentors-page .help-request-take-btn {
  background: #48bb78;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}

.mentors-page .help-request-take-btn:hover {
  background: #38a169;
  transform: scale(1.02);
}

/* Стилі для відповідей на запити */
.mentors-page .answered-requests-section {
  border-top: 2px dashed #cbd5e0;
  padding-top: 15px;
  margin-top: 5px;
}

.mentors-page .answered-requests-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #2d3748;
  font-weight: 500;
  transition: background-color 0.2s;
}

.mentors-page .answered-requests-header:hover {
  background: #dee2e6;
}

.mentors-page .answered-requests-icon {
  font-size: 12px;
}

.mentors-page .answered-requests-title {
  font-weight: 600;
}

.mentors-page .answered-requests-list {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mentors-page .answered-request-card {
  background: #f0fff4;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border: 1px solid #c6f6d5;
  transition: all 0.2s;
}

.mentors-page .answered-request-card:hover {
  background: #e6fffa;
}

.mentors-page .answered-request-info {
  flex: 1 1;
}

.mentors-page .answered-request-user {
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 4px;
  font-size: 14px;
}

.mentors-page .answered-request-task {
  font-size: 13px;
  color: #4a5568;
  margin-bottom: 4px;
}

.mentors-page .answered-request-mentor {
  font-size: 12px;
  color: #805ad5;
  margin-bottom: 4px;
}

.mentors-page .answered-request-answer {
  font-size: 12px;
  color: #2b6cb0;
  margin-bottom: 4px;
}

.mentors-page .answered-request-timer {
  font-size: 13px;
  font-weight: 600;
  color: #e53e3e;
  margin-top: 4px;
}

.mentors-page .answered-request-timer.expired {
  color: #c53030;
}

.mentors-page .answered-request-status {
  font-size: 12px;
  color: #38a169;
  font-weight: 500;
  margin-top: 4px;
}

.mentors-page .answered-request-link {
  color: #4299e1;
  text-decoration: none;
  font-size: 20px;
  padding: 6px 12px;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.mentors-page .answered-request-card:hover .answered-request-link {
  opacity: 1;
}

/* Стилі для модального вікна */
.mentors-page .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.mentors-page .modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 450px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: modalSlideIn 0.3s ease;
}

@keyframes modalSlideIn {
  from {
      opacity: 0;
      transform: translateY(-20px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
}

.mentors-page .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px 12px 0 0;
}

.mentors-page .modal-header h3 {
  margin: 0;
  color: white;
  font-size: 18px;
}

.mentors-page .modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.mentors-page .modal-close:hover {
  opacity: 1;
}

.mentors-page .modal-body {
  padding: 20px;
}

.mentors-page .modal-task-info {
  background: #f7fafc;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
}

.mentors-page .modal-task-info div {
  margin-bottom: 6px;
}

.mentors-page .modal-task-info div:last-child {
  margin-bottom: 0;
}

.mentors-page .modal-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mentors-page .modal-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.mentors-page .modal-option:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
}

.mentors-page .modal-option input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.mentors-page .modal-option span {
  font-size: 14px;
  color: #2d3748;
}

.mentors-page .minutes-input {
  width: 70px;
  padding: 6px 10px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
  margin-left: auto;
}

.mentors-page .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #e2e8f0;
}

.mentors-page .modal-cancel {
  padding: 8px 20px;
  background: #edf2f7;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #4a5568;
  transition: all 0.2s;
}

.mentors-page .modal-cancel:hover {
  background: #e2e8f0;
}

.mentors-page .modal-submit {
  padding: 8px 20px;
  background: #48bb78;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: white;
  font-weight: 500;
  transition: all 0.2s;
}

.mentors-page .modal-submit:hover {
  background: #38a169;
}

/* Темна тема */
.mentors-page.dark-theme .help-requests-column {
  background: #2d3748;
  border-color: #4a5568;
}

.mentors-page.dark-theme .help-requests-content {
  background: #1a202c;
}

.mentors-page.dark-theme .help-requests-subheader {
  background: #2d3748;
  color: #e2e8f0;
}

.mentors-page.dark-theme .help-request-card {
  background: #2d3748;
  border-color: #4a5568;
}

.mentors-page.dark-theme .help-request-card:hover {
  background: #374151;
}

.mentors-page.dark-theme .help-request-user {
  color: #e2e8f0;
}

.mentors-page.dark-theme .help-request-task {
  color: #cbd5e0;
}

.mentors-page.dark-theme .answered-requests-header {
  background: #2d3748;
  color: #e2e8f0;
}

.mentors-page.dark-theme .answered-requests-header:hover {
  background: #374151;
}

.mentors-page.dark-theme .answered-request-card {
  background: #2d3748;
  border-color: #4a5568;
}

.mentors-page.dark-theme .answered-request-card:hover {
  background: #374151;
}

.mentors-page.dark-theme .answered-request-user {
  color: #e2e8f0;
}

.mentors-page.dark-theme .answered-request-task {
  color: #cbd5e0;
}

.mentors-page.dark-theme .modal-content {
  background: #2d3748;
}

.mentors-page.dark-theme .modal-task-info {
  background: #1a202c;
  color: #e2e8f0;
}

.mentors-page.dark-theme .modal-option {
  border-color: #4a5568;
}

.mentors-page.dark-theme .modal-option:hover {
  background: #374151;
}

.mentors-page.dark-theme .modal-option span {
  color: #e2e8f0;
}

.mentors-page.dark-theme .modal-cancel {
  background: #4a5568;
  color: #e2e8f0;
}

.mentors-page.dark-theme .modal-cancel:hover {
  background: #374151;
}
/* Стилі для статусу в HelpRequestItem */
.help-request-status {
  margin-top: 4px;
}

.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.status-badge.status-in-progress {
  background-color: #4caf50;
  color: white;
}

.status-badge.status-in-queue {
  background-color: #ff9800;
  color: white;
}

/* Для темної теми */
.dark-theme .status-badge.status-in-progress {
  background-color: #2e7d32;
}

.dark-theme .status-badge.status-in-queue {
  background-color: #ed6c02;
}`, "",{"version":3,"sources":["webpack://./src/components/covfile/MentorsPage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB,mFAAmF;;AAEnF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,WAAW;EACb;;EAEA;IACE,SAAO;IACP,YAAY,EAAE,iCAAiC;EACjD;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,kCAAkC;IAClC,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAO;IACP,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;IAC3B,sCAAsC;IACtC,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,8CAA8C;EAChD;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,UAAU;IACV,oCAAoC;IACpC,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,6CAA6C;IAC7C,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,wBAAwB;IACxB,6CAA6C;EAC/C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,8CAA8C;EAChD;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,eAAe;IACf,YAAY;EACd;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA,qBAAqB;EACrB;;IAEE,UAAU;EACZ;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;;IAEE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;EACA,mDAAmD;;AAErD,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,qFAAqF;EACrF,iCAAiC;AACnC;;AAEA;EACE;MACI,UAAU;MACV,4BAA4B;EAChC;EACA;MACI,UAAU;MACV,wBAAwB;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA,wCAAwC;AACxC;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* MentorsPage.css */\r\n/* Всі стилі обгорнуті селектором .mentors-page, щоб не впливати на інші сторінки */\r\n\r\n.mentors-page .mentor-tasks-layout {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .mentors-page .columns-row {\r\n    display: flex;\r\n    gap: 20px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .mentors-page .columns-row .mentor-tasks-column {\r\n    flex: 1;\r\n    min-width: 0; /* Для запобігання переповнення */\r\n  }\r\n  \r\n  .mentors-page .mentor-tasks-column {\r\n    background: white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: fit-content;\r\n    max-height: 800px;\r\n  }\r\n  \r\n  .mentors-page .column-header {\r\n    padding: 15px 20px;\r\n    color: white;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .mentors-page .column-header h3 {\r\n    margin: 0;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    text-shadow: 0 1px 2px rgba(0,0,0,0.2);\r\n  }\r\n  \r\n  .mentors-page .tasks-count {\r\n    background: rgba(255,255,255,0.25);\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .mentors-page .tasks-container {\r\n    padding: 15px;\r\n    overflow-y: auto;\r\n    flex: 1;\r\n    background: #f8f9fc;\r\n  }\r\n  \r\n  .mentors-page .visible-tasks {\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-section {\r\n    border-top: 2px dashed #cbd5e0;\r\n    padding-top: 15px;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 10px 12px;\r\n    background: #e9ecef;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    color: #2d3748;\r\n    font-weight: 500;\r\n    transition: background-color 0.2s;\r\n    border: 1px solid #d0d9e4;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-header:hover {\r\n    background: #dee2e6;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-icon {\r\n    font-size: 12px;\r\n    color: #4a5568;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-title {\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-list {\r\n    margin-top: 12px;\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card {\r\n    position: relative;\r\n    background: white;\r\n    border-radius: 8px;\r\n    margin-bottom: 12px;\r\n    padding: 14px;\r\n    overflow: hidden;\r\n    transition: all 0.2s ease;\r\n    border: 1px solid #e2e8f0;\r\n    box-shadow: 0 1px 3px rgba(0,0,0,0.05);\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 16px rgba(0,0,0,0.1);\r\n    border-color: #cbd5e0;\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card.blocker {\r\n    border-left: 5px solid #f44336;\r\n    background: #fff5f5;\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card.blocker:hover {\r\n    background: #fff0f0;\r\n  }\r\n  \r\n  .mentors-page .task-progress-bar {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 4px;\r\n    transition: width 1s linear;\r\n    opacity: 0.9;\r\n  }\r\n  \r\n  .mentors-page .task-content {\r\n    position: relative;\r\n    z-index: 1;\r\n  }\r\n  \r\n  .mentors-page .task-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: 10px;\r\n    font-size: 14px;\r\n    color: #4a5568;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .mentors-page .user-name {\r\n    font-weight: 600;\r\n    color: #1a202c;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n  }\r\n  \r\n  .mentors-page .user-name span.role-icon {\r\n    font-size: 16px;\r\n    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.1));\r\n  }\r\n  \r\n  .mentors-page .start-time {\r\n    color: #718096;\r\n    font-weight: 500;\r\n    background: #edf2f7;\r\n    padding: 2px 8px;\r\n    border-radius: 12px;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .mentors-page .task-name {\r\n    font-weight: 600;\r\n    margin-bottom: 6px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    color: #1a202c;\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .mentors-page .task-project {\r\n    font-size: 13px;\r\n    color: #4a5568;\r\n    margin-bottom: 10px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    background: #edf2f7;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    display: inline-block;\r\n    max-width: 100%;\r\n  }\r\n  \r\n  .mentors-page .task-timer {\r\n    font-size: 15px;\r\n    color: #2d3748;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    background: #e2e8f0;\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    width: fit-content;\r\n  }\r\n  \r\n  .mentors-page .task-timer:before {\r\n    content: \"⏱️\";\r\n    margin-right: 4px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .mentors-page .task-link-arrow {\r\n    position: absolute;\r\n    bottom: 14px;\r\n    right: 14px;\r\n    font-size: 20px;\r\n    color: #a0aec0;\r\n    opacity: 0;\r\n    transition: opacity 0.2s, color 0.2s;\r\n    background: white;\r\n    width: 28px;\r\n    height: 28px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card:hover .task-link-arrow {\r\n    opacity: 1;\r\n    color: #4299e1;\r\n  }\r\n  \r\n  .mentors-page .no-tasks-message {\r\n    text-align: center;\r\n    color: #718096;\r\n    padding: 30px 20px;\r\n    font-style: italic;\r\n    background: #f7fafc;\r\n    border-radius: 6px;\r\n    border: 1px dashed #cbd5e0;\r\n  }\r\n  \r\n  .mentors-page .show-all-tasks-btn {\r\n    padding: 12px 24px;\r\n    background: #4299e1;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    align-self: center;\r\n    margin: 15px 0 10px;\r\n    min-width: 220px;\r\n    transition: all 0.2s;\r\n    box-shadow: 0 2px 4px rgba(66, 153, 225, 0.3);\r\n    border: 1px solid #3182ce;\r\n  }\r\n  \r\n  .mentors-page .show-all-tasks-btn:hover {\r\n    background: #3182ce;\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 8px rgba(66, 153, 225, 0.4);\r\n  }\r\n  \r\n  .mentors-page .show-all-tasks-btn:active {\r\n    transform: translateY(0);\r\n    box-shadow: 0 1px 2px rgba(66, 153, 225, 0.3);\r\n  }\r\n  \r\n  .mentors-page .all-tasks-view {\r\n    margin-top: 25px;\r\n  }\r\n  \r\n  .mentors-page .all-tasks-view h3 {\r\n    margin-bottom: 15px;\r\n    color: #1a202c;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    padding-left: 5px;\r\n  }\r\n  \r\n  .mentors-page .users-columns {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n    gap: 20px;\r\n  }\r\n  \r\n  .mentors-page .user-column {\r\n    background: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 6px rgba(0,0,0,0.08);\r\n    overflow: hidden;\r\n    border: 1px solid #e2e8f0;\r\n  }\r\n  \r\n  .mentors-page .user-header {\r\n    padding: 14px 16px;\r\n    background: #f8fafc;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #e2e8f0;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  .mentors-page .user-header:hover {\r\n    background: #edf2f7;\r\n  }\r\n  \r\n  .mentors-page .user-header .user-name {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    font-weight: 600;\r\n    color: #1a202c;\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .mentors-page .role-icon {\r\n    font-size: 20px;\r\n    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.1));\r\n  }\r\n  \r\n  .mentors-page .collapse-btn {\r\n    background: white;\r\n    border: 1px solid #cbd5e0;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    color: #4a5568;\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n    transition: all 0.2s;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .mentors-page .collapse-btn:hover {\r\n    background: #e2e8f0;\r\n    border-color: #a0aec0;\r\n  }\r\n  \r\n  .mentors-page .user-column.collapsed .user-header {\r\n    background: #edf2f7;\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .mentors-page .user-statuses {\r\n    padding: 12px;\r\n    background: #ffffff;\r\n  }\r\n  \r\n  .mentors-page .status-section {\r\n    margin-bottom: 12px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: white;\r\n  }\r\n  \r\n  .mentors-page .status-header {\r\n    padding: 10px 12px;\r\n    background: #f8fafc;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    border-bottom: 1px solid #e2e8f0;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  .mentors-page .status-header:hover {\r\n    background: #edf2f7;\r\n  }\r\n  \r\n  .mentors-page .status-name {\r\n    flex: 1;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .mentors-page .status-name[data-status=\"В роботі\"],\r\n  .mentors-page .status-name[data-status=\"В работе\"],\r\n  .mentors-page .status-name[data-status=\"In progress\"] {\r\n    color: #2563eb;\r\n  }\r\n  \r\n  .mentors-page .status-name[data-status=\"Черговому\"],\r\n  .mentors-page .status-name[data-status=\"Дежурному\"] {\r\n    color: #dd6b20;\r\n  }\r\n  \r\n  .mentors-page .status-name[data-status=\"В черзі\"],\r\n  .mentors-page .status-name[data-status=\"В очереди\"] {\r\n    color: #7b3fe4;\r\n  }\r\n  \r\n  .mentors-page .status-name[data-status=\"В черзі (м'яч не у нас)\"],\r\n  .mentors-page .status-name[data-status=\"В очереди (мяч не у нас)\"] {\r\n    color: #b45309;\r\n  }\r\n  \r\n  .mentors-page .task-count {\r\n    color: #4a5568;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    background: #e2e8f0;\r\n    padding: 2px 8px;\r\n    border-radius: 16px;\r\n  }\r\n  \r\n  .mentors-page .collapse-icon {\r\n    font-size: 12px;\r\n    color: #718096;\r\n    margin-left: 4px;\r\n  }\r\n  \r\n  .mentors-page .tasks-list {\r\n    padding: 8px;\r\n    background: white;\r\n  }\r\n  \r\n  .mentors-page .task-item-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 10px 12px;\r\n    border-bottom: 1px solid #f0f4f8;\r\n    font-size: 13px;\r\n    transition: background-color 0.2s;\r\n    background: white;\r\n  }\r\n  \r\n  .mentors-page .task-item-wrapper:hover {\r\n    background: #f8fafc;\r\n  }\r\n  \r\n  .mentors-page .task-item-wrapper:last-child {\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .mentors-page .task-info-compact {\r\n    flex: 1;\r\n    min-width: 0;\r\n  }\r\n  \r\n  .mentors-page .task-name-small {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    color: #1a202c;\r\n    font-weight: 500;\r\n    margin-bottom: 4px;\r\n  }\r\n  \r\n  .mentors-page .task-time-small {\r\n    font-size: 12px;\r\n    color: #718096;\r\n    font-weight: 500;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .mentors-page .task-time-small:before {\r\n    content: \"⏱️\";\r\n    font-size: 11px;\r\n    opacity: 0.7;\r\n  }\r\n  \r\n  .mentors-page .task-link-small {\r\n    color: #4299e1;\r\n    text-decoration: none;\r\n    font-size: 16px;\r\n    padding: 6px 10px;\r\n    opacity: 0;\r\n    transition: all 0.2s;\r\n    background: #ebf8ff;\r\n    border-radius: 20px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .mentors-page .task-item-wrapper:hover .task-link-small {\r\n    opacity: 1;\r\n    color: #2b6cb0;\r\n  }\r\n  \r\n  /* Стилі для скролу */\r\n  .mentors-page .tasks-container::-webkit-scrollbar,\r\n  .mentors-page .tasks-list::-webkit-scrollbar {\r\n    width: 8px;\r\n  }\r\n  \r\n  .mentors-page .tasks-container::-webkit-scrollbar-track,\r\n  .mentors-page .tasks-list::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .mentors-page .tasks-container::-webkit-scrollbar-thumb,\r\n  .mentors-page .tasks-list::-webkit-scrollbar-thumb {\r\n    background: #cbd5e0;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .mentors-page .tasks-container::-webkit-scrollbar-thumb:hover,\r\n  .mentors-page .tasks-list::-webkit-scrollbar-thumb:hover {\r\n    background: #a0aec0;\r\n  }\r\n  \r\n  /* Стилі для loading та error станів */\r\n  .mentors-page .loading,\r\n  .mentors-page .error {\r\n    text-align: center;\r\n    padding: 40px;\r\n    font-size: 18px;\r\n    color: #4a5568;\r\n  }\r\n  \r\n  .mentors-page .error {\r\n    color: #e53e3e;\r\n  }\r\n  /* MentorsPage.css - додайте ці стилі до існуючих */\r\n\r\n/* Стилі для колонки запитів на допомогу */\r\n.mentors-page .help-requests-column {\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n  overflow: hidden;\r\n  margin-top: 10px;\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.mentors-page .help-requests-header {\r\n  padding: 15px 20px;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.mentors-page .help-requests-header:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n.mentors-page .help-requests-icon {\r\n  font-size: 14px;\r\n}\r\n\r\n.mentors-page .help-requests-title {\r\n  font-size: 16px;\r\n}\r\n\r\n.mentors-page .help-requests-content {\r\n  padding: 15px;\r\n  background: #f8f9fc;\r\n}\r\n\r\n.mentors-page .help-requests-section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.mentors-page .help-requests-subheader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 12px;\r\n  background: #e9ecef;\r\n  border-radius: 6px;\r\n  margin-bottom: 12px;\r\n  font-weight: 600;\r\n  color: #2d3748;\r\n}\r\n\r\n.mentors-page .requests-count {\r\n  background: #667eea;\r\n  color: white;\r\n  padding: 2px 10px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n}\r\n\r\n.mentors-page .help-requests-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.mentors-page .help-request-card {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  border: 1px solid #e2e8f0;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.mentors-page .help-request-card:hover {\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.mentors-page .help-request-info {\r\n  flex: 1;\r\n}\r\n\r\n.mentors-page .help-request-user {\r\n  font-weight: 600;\r\n  color: #2d3748;\r\n  margin-bottom: 4px;\r\n  font-size: 14px;\r\n}\r\n\r\n.mentors-page .help-request-task {\r\n  font-size: 13px;\r\n  color: #4a5568;\r\n  margin-bottom: 4px;\r\n  word-break: break-word;\r\n}\r\n\r\n.mentors-page .help-request-project {\r\n  font-size: 12px;\r\n  color: #718096;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.mentors-page .help-request-time {\r\n  font-size: 12px;\r\n  color: #e53e3e;\r\n  font-weight: 500;\r\n}\r\n\r\n.mentors-page .help-request-take-btn {\r\n  background: #48bb78;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 8px 16px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mentors-page .help-request-take-btn:hover {\r\n  background: #38a169;\r\n  transform: scale(1.02);\r\n}\r\n\r\n/* Стилі для відповідей на запити */\r\n.mentors-page .answered-requests-section {\r\n  border-top: 2px dashed #cbd5e0;\r\n  padding-top: 15px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.mentors-page .answered-requests-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  background: #e9ecef;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #2d3748;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.mentors-page .answered-requests-header:hover {\r\n  background: #dee2e6;\r\n}\r\n\r\n.mentors-page .answered-requests-icon {\r\n  font-size: 12px;\r\n}\r\n\r\n.mentors-page .answered-requests-title {\r\n  font-weight: 600;\r\n}\r\n\r\n.mentors-page .answered-requests-list {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.mentors-page .answered-request-card {\r\n  background: #f0fff4;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  border: 1px solid #c6f6d5;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.mentors-page .answered-request-card:hover {\r\n  background: #e6fffa;\r\n}\r\n\r\n.mentors-page .answered-request-info {\r\n  flex: 1;\r\n}\r\n\r\n.mentors-page .answered-request-user {\r\n  font-weight: 600;\r\n  color: #2d3748;\r\n  margin-bottom: 4px;\r\n  font-size: 14px;\r\n}\r\n\r\n.mentors-page .answered-request-task {\r\n  font-size: 13px;\r\n  color: #4a5568;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.mentors-page .answered-request-mentor {\r\n  font-size: 12px;\r\n  color: #805ad5;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.mentors-page .answered-request-answer {\r\n  font-size: 12px;\r\n  color: #2b6cb0;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.mentors-page .answered-request-timer {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #e53e3e;\r\n  margin-top: 4px;\r\n}\r\n\r\n.mentors-page .answered-request-timer.expired {\r\n  color: #c53030;\r\n}\r\n\r\n.mentors-page .answered-request-status {\r\n  font-size: 12px;\r\n  color: #38a169;\r\n  font-weight: 500;\r\n  margin-top: 4px;\r\n}\r\n\r\n.mentors-page .answered-request-link {\r\n  color: #4299e1;\r\n  text-decoration: none;\r\n  font-size: 20px;\r\n  padding: 6px 12px;\r\n  opacity: 0.7;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.mentors-page .answered-request-card:hover .answered-request-link {\r\n  opacity: 1;\r\n}\r\n\r\n/* Стилі для модального вікна */\r\n.mentors-page .modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.mentors-page .modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 450px;\r\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n  animation: modalSlideIn 0.3s ease;\r\n}\r\n\r\n@keyframes modalSlideIn {\r\n  from {\r\n      opacity: 0;\r\n      transform: translateY(-20px);\r\n  }\r\n  to {\r\n      opacity: 1;\r\n      transform: translateY(0);\r\n  }\r\n}\r\n\r\n.mentors-page .modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px 20px;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  border-radius: 12px 12px 0 0;\r\n}\r\n\r\n.mentors-page .modal-header h3 {\r\n  margin: 0;\r\n  color: white;\r\n  font-size: 18px;\r\n}\r\n\r\n.mentors-page .modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: white;\r\n  opacity: 0.8;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.mentors-page .modal-close:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.mentors-page .modal-body {\r\n  padding: 20px;\r\n}\r\n\r\n.mentors-page .modal-task-info {\r\n  background: #f7fafc;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n  font-size: 14px;\r\n}\r\n\r\n.mentors-page .modal-task-info div {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.mentors-page .modal-task-info div:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.mentors-page .modal-options {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.mentors-page .modal-option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.mentors-page .modal-option:hover {\r\n  background: #f7fafc;\r\n  border-color: #cbd5e0;\r\n}\r\n\r\n.mentors-page .modal-option input[type=\"radio\"] {\r\n  width: 18px;\r\n  height: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.mentors-page .modal-option span {\r\n  font-size: 14px;\r\n  color: #2d3748;\r\n}\r\n\r\n.mentors-page .minutes-input {\r\n  width: 70px;\r\n  padding: 6px 10px;\r\n  border: 1px solid #cbd5e0;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  margin-left: auto;\r\n}\r\n\r\n.mentors-page .modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  padding: 16px 20px;\r\n  border-top: 1px solid #e2e8f0;\r\n}\r\n\r\n.mentors-page .modal-cancel {\r\n  padding: 8px 20px;\r\n  background: #edf2f7;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #4a5568;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.mentors-page .modal-cancel:hover {\r\n  background: #e2e8f0;\r\n}\r\n\r\n.mentors-page .modal-submit {\r\n  padding: 8px 20px;\r\n  background: #48bb78;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: white;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.mentors-page .modal-submit:hover {\r\n  background: #38a169;\r\n}\r\n\r\n/* Темна тема */\r\n.mentors-page.dark-theme .help-requests-column {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n}\r\n\r\n.mentors-page.dark-theme .help-requests-content {\r\n  background: #1a202c;\r\n}\r\n\r\n.mentors-page.dark-theme .help-requests-subheader {\r\n  background: #2d3748;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.mentors-page.dark-theme .help-request-card {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n}\r\n\r\n.mentors-page.dark-theme .help-request-card:hover {\r\n  background: #374151;\r\n}\r\n\r\n.mentors-page.dark-theme .help-request-user {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.mentors-page.dark-theme .help-request-task {\r\n  color: #cbd5e0;\r\n}\r\n\r\n.mentors-page.dark-theme .answered-requests-header {\r\n  background: #2d3748;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.mentors-page.dark-theme .answered-requests-header:hover {\r\n  background: #374151;\r\n}\r\n\r\n.mentors-page.dark-theme .answered-request-card {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n}\r\n\r\n.mentors-page.dark-theme .answered-request-card:hover {\r\n  background: #374151;\r\n}\r\n\r\n.mentors-page.dark-theme .answered-request-user {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.mentors-page.dark-theme .answered-request-task {\r\n  color: #cbd5e0;\r\n}\r\n\r\n.mentors-page.dark-theme .modal-content {\r\n  background: #2d3748;\r\n}\r\n\r\n.mentors-page.dark-theme .modal-task-info {\r\n  background: #1a202c;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.mentors-page.dark-theme .modal-option {\r\n  border-color: #4a5568;\r\n}\r\n\r\n.mentors-page.dark-theme .modal-option:hover {\r\n  background: #374151;\r\n}\r\n\r\n.mentors-page.dark-theme .modal-option span {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.mentors-page.dark-theme .modal-cancel {\r\n  background: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.mentors-page.dark-theme .modal-cancel:hover {\r\n  background: #374151;\r\n}\r\n/* Стилі для статусу в HelpRequestItem */\r\n.help-request-status {\r\n  margin-top: 4px;\r\n}\r\n\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 2px 8px;\r\n  border-radius: 12px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.status-in-progress {\r\n  background-color: #4caf50;\r\n  color: white;\r\n}\r\n\r\n.status-badge.status-in-queue {\r\n  background-color: #ff9800;\r\n  color: white;\r\n}\r\n\r\n/* Для темної теми */\r\n.dark-theme .status-badge.status-in-progress {\r\n  background-color: #2e7d32;\r\n}\r\n\r\n.dark-theme .status-badge.status-in-queue {\r\n  background-color: #ed6c02;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
